import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageLoader } from "@/components/Loading";
import DashboardLayout from "@/components/DashboardLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Programs from "@/pages/Programs";
import ProgramDetail from "@/pages/ProgramDetail";
import Enrollments from "@/pages/Enrollments";
import Lectures from "@/pages/Lectures";
import Attendance from "@/pages/Attendance";
import Assignments from "@/pages/Assignments";
import Teachers from "@/pages/Teachers";
import Units from "@/pages/Units";
import CalendarPage from "@/pages/CalendarPage";
import Announcements from "@/pages/Announcements";
import Grades from "@/pages/Grades";
import Reports from "@/pages/Reports";
import Evaluations from "@/pages/Evaluations";
import PendingSupervisor from "@/pages/PendingSupervisor";
import SupervisorRequests from "@/pages/SupervisorRequests";
import Assistant from "@/pages/Assistant";
import Leaderboard from "@/pages/Leaderboard";
import UnitDetail from "@/pages/UnitDetail";
import StudentProfile from "@/pages/StudentProfile";
import Mosques from "@/pages/Mosques";
import Chat from "@/pages/Chat";
import Complaints from "@/pages/Complaints";
import Social from "@/pages/Social";
import Album from "@/pages/Album";
import Activities from "@/pages/Activities";
import MyActivities from "@/pages/MyActivities";
import AttendanceLogs from "@/pages/AttendanceLogs";
import Certificates from "@/pages/Certificates";
import VerifyCertificate from "@/pages/VerifyCertificate";
import Consultants from "@/pages/Consultants";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <PageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "pending_supervisor") return <PendingSupervisor />;
  return <DashboardLayout>{children}</DashboardLayout>;
}

function PublicOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <PageLoader />;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
        <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
        <Route path="/verify-certificate/:code" element={<VerifyCertificate />} />
        <Route path="/app" element={<Protected><Dashboard /></Protected>} />
        <Route path="/app/programs" element={<Protected><Programs /></Protected>} />
        <Route path="/app/programs/:id" element={<Protected><ProgramDetail /></Protected>} />
        <Route path="/app/enrollments" element={<Protected><Enrollments /></Protected>} />
        <Route path="/app/lectures" element={<Protected><Lectures /></Protected>} />
        <Route path="/app/attendance" element={<Protected><Attendance /></Protected>} />
        <Route path="/app/assignments" element={<Protected><Assignments /></Protected>} />
        <Route path="/app/teachers" element={<Protected><Teachers /></Protected>} />
        <Route path="/app/units" element={<Protected><Units /></Protected>} />
        <Route path="/app/calendar" element={<Protected><CalendarPage /></Protected>} />
        <Route path="/app/announcements" element={<Protected><Announcements /></Protected>} />
        <Route path="/app/grades" element={<Protected><Grades /></Protected>} />
        <Route path="/app/reports" element={<Protected><Reports /></Protected>} />
        <Route path="/app/evaluations" element={<Protected><Evaluations /></Protected>} />
        <Route path="/app/supervisor-requests" element={<Protected><SupervisorRequests /></Protected>} />
        <Route path="/app/assistant" element={<Protected><Assistant /></Protected>} />
        <Route path="/app/leaderboard" element={<Protected><Leaderboard /></Protected>} />
        <Route path="/app/units/:id" element={<Protected><UnitDetail /></Protected>} />
        <Route path="/app/students/:id" element={<Protected><StudentProfile /></Protected>} />
        <Route path="/app/mosques" element={<Protected><Mosques /></Protected>} />
        <Route path="/app/chat" element={<Protected><Chat /></Protected>} />
        <Route path="/app/complaints" element={<Protected><Complaints /></Protected>} />
        <Route path="/app/social" element={<Protected><Social /></Protected>} />
        <Route path="/app/album" element={<Protected><Album /></Protected>} />
        <Route path="/app/activities" element={<Protected><Activities /></Protected>} />
        <Route path="/app/my-activities" element={<Protected><MyActivities /></Protected>} />
        <Route path="/app/attendance-logs" element={<Protected><AttendanceLogs /></Protected>} />
        <Route path="/app/certificates" element={<Protected><Certificates /></Protected>} />
        <Route path="/app/consultants" element={<Protected><Consultants /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
